import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/UserWithdrawal`;

const ApiUserWithdrawal = {
  getAllUserWithdrawal: (params) => {
    const url = `${baseServiceUrl}/getAllUserWithdrawal`;
    return ServiceApi.get(url, { params });
  },
  getUserWithdrawalById: (params) => {
    const url = `${baseServiceUrl}/getUserWithdrawalById`;
    return ServiceApi.get(url, { params });
  },
  getUserWithdrawalStatus: () => {
    const url = `${baseServiceUrl}/getUserWithdrawalStatus`;
    return ServiceApi.get(url);
  },
  updateUserWithdrawal: (data) => {
    const url = `${baseServiceUrl}/updateUserWithdrawalStatus`;
    return ServiceApi.put(url, data);
  },
  deleteWithdrawal: (params) => {
    const url = `${baseServiceUrl}/deleteUserWithdrawal`;
    return ServiceApi.put(url, params);
  },
  createSupplierWithdrawal: (params) => {
    const url = `${baseServiceUrl}/createSupplierWithdrawal`;
    return ServiceApi.post(url, params);
  },
  getAllUserWithdrawalByExcel: (params) => {
    const url = `${baseServiceUrl}/getAllUserWithdrawalByExcel`;
    return ServiceApi.get(url, { params: params, responseType: "blob" });
  },
};

export default ApiUserWithdrawal;
